import { Outlet, createFileRoute } from '@tanstack/react-router';

import { SettingsPageLayout } from '@/components/Settings/SettingsPageLayout';

export const Route = createFileRoute('/$organizationName/cb/$codebaseId/settings')({
  component: CodebaseSettingsLayout,
});

function CodebaseSettingsLayout() {
  return (
    // Sits beside the About column in the codebase layout's left panel, so
    // the content is left-aligned next to it (not centered) and drops its top
    // padding so both columns start at the same height.
    <SettingsPageLayout hideSeparator innerClassName="mx-0 max-w-4xl pt-0">
      <Outlet />
    </SettingsPageLayout>
  );
}
